import { MasterRepo } from './../../common/repositories/masterRepo.service';
import { LoginService } from './loginService.service';
import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
  AbstractControl,
} from '@angular/forms';
import { Subscription } from 'rxjs';
import { ModalDirective } from 'ngx-bootstrap/modal';
@Component({
  selector: 'newPassword',
  templateUrl: './newPassword.component.html',
  styleUrls: ['./forgetPassword.css'],
})
export class NewPasswordComp {
  newpassword = true;
  public form: FormGroup;
  username: any;
  DialogMessage: string = ' ';
  @ViewChild('childModal') childModal!: ModalDirective;
  private subcriptions: Array<Subscription> = [];
  constructor(
    fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private loginService: LoginService,
    private masterService: MasterRepo
  ) {
    this.newpassword = false;
    this.form = fb.group({
      Username: [''],
      NewPwd: ['', Validators.required],
    });
    // this.loginService.UsersObj.result._id;
    // this.security = this.form.controls['Security'];
  }
  confirmPassword() {
    this.DialogMessage = 'please wait..';
    this.childModal.show();
    this.form.patchValue({
      Username: this.loginService.UsersObj.result.userId,
    });
    // console.log("check new",this.form.value,this.loginService.UsersObj.result)
    // this.username = this.loginService.UsersObj.username;
    let sub = this.masterService.saveforgetPassword(this.form.value).subscribe(
      (data: any) => {
        console.log('savePassword', data);
        if (data.status == 'ok') {
          this.DialogMessage = 'New Password Saved!';
          // this.ngOnInit();
          setTimeout(() => {
            this.childModal.hide();
            this.childModal.hide();
            this.loginService.loginpage = true;
            this.loginService.securityCode = false;
            this.loginService.sendMail = false;
            this.loginService.newPassword = false;
          }, 2000);
        } else if (data.status == 'oldpassword') {
          this.DialogMessage = 'Old Password is incorrect!';
          // this.ngOnInit();
          setTimeout(() => {
            this.childModal.hide();
            // this.router.navigate([this.returnUrl]);
          }, 1000);
        } else {
          //alert(data.result);
          //the ConnectionString in the server is not initialized means the the token 's user is not int the list of database user so it could't make connectionstring. Re authorization is requierd
          // if (data.result._body == "The ConnectionString property has not been initialized.") {
          //     this.router.navigate(['/login', this.router.url])
          //     return;
          // }
          //Some other issues need to check
          this.DialogMessage = 'Error in Saving Data:' + data.result._body;
          console.log(data.result._body);
          setTimeout(() => {
            this.childModal.hide();
          }, 3000);
        }
      },
      (error: any) => {
        alert(error);
      }
    );
    this.subcriptions.push(sub);
  }
  Cancel() {
    this.loginService.newPassword = false;
    this.loginService.loginpage = true;
    this.loginService.securityCode = false;
    this.loginService.sendMail = false;
  }
  hideChildModal() {
    this.childModal.hide();
  }
}
